import { Component, Inject, Input } from '@angular/core';
import { fromEvent } from 'rxjs';

import { BaseEditor } from '../../base/base-editor';
import { NGX_MONACO_EDITOR_CONFIG, NgxMonacoEditorConfig } from '../../config/config';
import { DiffEditorModel } from '../../types/types';

declare var monaco: any;

@Component({
  selector: 'app-monaco-diff-editor',
  templateUrl: './monaco-diff-editor.component.html',
  styleUrls: ['./monaco-diff-editor.component.css'],
})
export class MonacoDiffEditorComponent extends BaseEditor {
  /**
   * @see {monaco.editor.IStandaloneDiffEditor}
   */
  editor: any;
  _originalModel: DiffEditorModel;
  _modifiedModel: DiffEditorModel;

  @Input('originalModel')
  set originalModel(model: DiffEditorModel) {
    this._originalModel = model;
    if (this.editor) {
      this.editor.dispose();
      this.initMonaco(this.options);
    }
  }

  @Input('modifiedModel')
  set modifiedModel(model: DiffEditorModel) {
    this._modifiedModel = model;
    if (this.editor) {
      this.editor.dispose();
      this.initMonaco(this.options);
    }
  }

  constructor(@Inject(NGX_MONACO_EDITOR_CONFIG) private editorConfig: NgxMonacoEditorConfig) {
    super(editorConfig);
    if(editorConfig && editorConfig.baseUrl) {
      let rootPath = (window as any).gspframeworkService.common.getBasePath.get();
      if(rootPath && !editorConfig.baseUrl.startsWith(rootPath)) {
        editorConfig.baseUrl += rootPath;
      }
    }
  }

  protected initMonaco(options: any): void {

    if (!this._originalModel || !this._modifiedModel) {
      throw new Error('originalModel or modifiedModel not found for ngx-monaco-diff-editor');
    }

    this._originalModel.language = this._originalModel.language || options.language;
    this._modifiedModel.language = this._modifiedModel.language || options.language;

    let originalModel = monaco.editor.createModel(this._originalModel.code, this._originalModel.language);
    let modifiedModel = monaco.editor.createModel(this._modifiedModel.code, this._modifiedModel.language);

    this._editorContainer.nativeElement.innerHTML = '';
    const theme = options.theme;
    this.editor = monaco.editor.createDiffEditor(this._editorContainer.nativeElement, options);
    options.theme = theme;
    this.editor.setModel({
      original: originalModel,
      modified: modifiedModel
    });

    // refresh layout on resize event.
    if (this._windowResizeSubscription) {
      this._windowResizeSubscription.unsubscribe();
    }
    this._windowResizeSubscription = fromEvent(window, 'resize').subscribe(() => this.editor.layout());
    this.onInit.emit(this.editor);
  }

}
